module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustra-2-5bd8b02313d2a2df11991ee610a7f961.png";